import React from "react";
import { DeltaInfo } from "../../../helpers/searchTrending";

const TONE_CLASSES: Record<DeltaInfo["tone"], string> = {
  new: "bg-green-100 text-green-700 px-1.5 py-0.5 rounded",
  up: "text-green-600",
  down: "text-red-600",
  flat: "text-gray-400",
};

const DeltaBadge: React.FC<{ info: DeltaInfo }> = ({ info }) => (
  <span className={`text-xs font-medium ${TONE_CLASSES[info.tone]}`}>
    {info.label}
  </span>
);

export default DeltaBadge;
